import React, { Component } from 'react';
import { db } from '../firebase';
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";


const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const loginStyle = {
  marginTop: 50,
  backgroundColor: "white"
};

const h2Style = {
  paddingLeft: 10,
  marginTop: 10,
  fontFamily: "Audiowide, cursive",
  color: "cadetblue"
};

class Parchment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      articleId: "",
      articleName: "",
      author: "",
      date: "",
      article: "",
      error: null
    };

    this.articleChange = this.articleChange.bind(this);
  }

  onSubmit = (event) => {
    var d = new Date();

    db.postArticle(this.state.articleId, this.state.articleName, this.state.article, this.state.author, d)

    event.preventDefault();
  }

  articleChange(value) {
    this.setState({article: value})
  }

  render() {
    const {
      articleId,
      articleName,
      author,
      article,
      error,
    } = this.state;

    var toolbarOptions = [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      ['link', 'image'],
      [{ align: '' }],
      [{ align: 'right' }],
      [{ align: 'center' }],
      [{ align: 'justify' }],
    ];

    var modules = {
      toolbar: toolbarOptions
    }

    var buttonStyle={
      marginTop: 10
    }

    return (
      <div style={loginStyle}  className="Site_Content, container">    
      <h2 style={h2Style}>Record this Mighty Work</h2>
      <Form onSubmit={this.onSubmit}>
      <FormGroup row>
        <Label  for="articleId" sm={2}>Article ID</Label>
        <Col sm={10}>
        <Input id="articleId"
          value={articleId}
          onChange={event => this.setState(byPropKey('articleId', event.target.value))}
          type="text"
        />
        </Col>
        </FormGroup>

        <FormGroup row>
          <Label  for="articleName" sm={2}>Article Name</Label>
          <Col sm={10}>
          <Input id="articleName"
            value={articleName}
            onChange={event => this.setState(byPropKey('articleName', event.target.value))}
            type="text"
          />
          </Col>
          </FormGroup>

          <FormGroup row>
            <Label  for="author" sm={2}>Author</Label>
            <Col sm={10}>
            <Input id="author"
              value={author}
              onChange={event => this.setState(byPropKey('author', event.target.value))}
              type="text"
            />
            </Col>
            </FormGroup>

      <FormGroup row>
        <Label  for="article" sm={2}>Article</Label>
        <Col sm={10}>

        <ReactQuill id="article"  modules={modules} value={this.state.article} onChange={this.articleChange} theme="snow"/>
        </Col>
        </FormGroup>

        <Button style={buttonStyle} type="submit">
          Post
        </Button>
        { error && <p>{error.message}</p> }
      </Form>
      </div>
    );
  }
}

export default Parchment;



// WEBPACK FOOTER //
// ./src/Admin/Parchment.js